import { addMinutes } from 'date-fns';
import { getTimezoneOffset, utcToZonedTime } from 'date-fns-tz';

/**
 * @param date
 * @param timeZone
 * Get a date/time in the local time of any time zone from UTC time
 * date: 2025-07-23T22:00:00.000Z
 * timezone: America/Adak   Summer=-9, Winter=-10
 *
 * return 2025-07-23T10:00:00.000Z
 */
export function formatDateByTimeZone(date: Date, timeZone: string): Date {
  if (date && timeZone) {
    return utcToZonedTime(date, timeZone);
  }
  return date;
}

/**
 * @param date
 * @param timezone
 * date: 2025-07-23T22:00:00.000Z
 * timezone: America/Adak   Summer=-9, Winter=-10
 * zoneOffset = -540
 * myTimezoneOffset = 180 (Locale time: +3)
 * return: 2025-07-24T10:00:00.000Z
 */
export function normalizeZonedDate(date: Date, timezone: string): Date {
  if (!date) {
    return null;
  }
  const zoneOffset = getTimezoneOffset(timezone, date) / 1000 / 60;
  const myTimezoneOffset = -1 * date.getTimezoneOffset();
  return addMinutes(date, myTimezoneOffset - zoneOffset);
}
